export var applyAccessor = function applyAccessor(accessor, data, index) {
  if (!accessor) {
    return data;
  }

  if (typeof accessor === 'string') {
    return data[accessor];
  }

  return accessor({
    data: data,
    index: index
  });
};
export var applyKeyAccessor = function applyKeyAccessor(accessor, dataItem, index) {
  if (typeof accessor === 'function') {
    return accessor(dataItem, index);
  }

  if (typeof accessor === 'string') {
    return dataItem[accessor];
  }

  return String(index);
};